<p-drawer
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  position="right"
>
  <ng-template #header>
    <div class="title">Notifications</div>
    <p-button severity="secondary"
              variant="text"
              size="small"
              label="Mark all as read"
              (click)="readAll()">
    </p-button>
  </ng-template>
  <div #scroller class="scroller" (scroll)="onScroll()">
    @for (item of items(); track item.id) {
      <app-notification-block
        [class.clickable]="item.readAt === null"
        [tooltipDisabled]="item.readAt !== null"
        pTooltip="Click to mark as read" tooltipPosition="left"
        (click)="markAsRead(item)" [notification]="item"></app-notification-block>
    }
  </div>
</p-drawer>
